import { useState } from "react";

export type FileFilterState = {
    fileTypes: string[];
};

export const defaultFileFilters: FileFilterState = {
    fileTypes: []
};

export const useFileFilters = () => {
    const [filters, setFilters] =
        useState<FileFilterState>(defaultFileFilters);

    return { filters, setFilters };
};
